import { LIST_CANDIDATE } from "../../constant";
import { Paragraph, PointText } from "../style/styled";
import { CompBar } from "./CompBar";

export function CompTextBrief({
  voting,
  town,
  votePeopleNum_19,
  voteNumRank_19,
}) {
  const numberWithCommas = (x) =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const votePeopleNumWithCommas = numberWithCommas(votePeopleNum_19);
  return (
    <Paragraph>
      <span>
        <PointText>{voting}</PointText> 동네인 {town}의 선거인수는 19대 대선
        기준으로 <PointText>{votePeopleNumWithCommas}</PointText>명으로
        우리나라에서 <PointText>{voteNumRank_19}</PointText>번째 선거인이 많은
        동네에요.박빙이 예상되는 이번 대선이 코앞인데 지난 선거에서 우리 동네는
        어떤 선택을 했을까요? 역대 우리 동네 대통령 선거 결과가 궁금하다면 아래
        ‘더 읽어보기'를 눌러주세요.
      </span>
    </Paragraph>
  );
}
export function CompTextHitRate({
  town,
  winner_16,
  winner_value_16,
  winner_17,
  winner_value_17,
  winner_18,
  winner_value_18,
  winner_19,
  winner_value_19,
  count_winner,
  sync_per,
}) {
  const sync_perNum = Number(sync_per);
  return (
    <Paragraph>
      <span>
        <PointText>{town}</PointText>는 16대 대선에서는{" "}
        <PointText>{LIST_CANDIDATE[winner_16]}</PointText> 후보가 득표율{" "}
        <PointText>{winner_value_16}%</PointText>로 1위, 17대 대선에서는{" "}
        <PointText>{LIST_CANDIDATE[winner_17]}</PointText> 후보가{" "}
        <PointText>{winner_value_17}%</PointText>로 1위, 18대 대선에서는{" "}
        <PointText>{LIST_CANDIDATE[winner_18]}</PointText> 후보가{" "}
        <PointText>{winner_value_18}%</PointText>로 1위, 가장 최근 치러진 19대
        대선에서는
        <PointText>{LIST_CANDIDATE[winner_19]}</PointText> 후보가{" "}
        <PointText>{winner_value_19}%</PointText>로 각 1위를 했어요. 2000년 이후
        치러진 4번의 선거에서 당선자를 <PointText>{count_winner}</PointText>번
        맞혔네요.
      </span>
      {sync_perNum === 0.25 && (
        <span>
          적중률 <PointText>{sync_per}%</PointText>로 한번밖에 당선자를 맞히며
          전국 판세랑은 다소 다른 표심을 보여줬어요.
        </span>
      )}
      {sync_perNum === 0.5 && (
        <span>
          적중률 <PointText>{sync_per}%</PointText>로 반은 맞고 반은 틀린 우리
          동네! 과연 이번에는 족집게 동네로 올라설 수 있을까요?
        </span>
      )}
      {sync_perNum === 0.75 && (
        <span>
          적중률 <PointText>{sync_per}%</PointText>로 아쉽게 한번 틀렸지만
          그래도 이만하면 족집게 동네에 가깝죠. 이번 선거에서는 기대해봐도
          좋겠죠?
        </span>
      )}
      {sync_perNum === 1 && (
        <span>
          적중률 <PointText>{sync_per}%</PointText>로 당선자를 모두 맞힌 족집게
          동네로 인정합니다! 이번 20대 대선에서도 당선자 맞힐 수 있겠죠?
        </span>
      )}
    </Paragraph>
  );
}

export function CompTextSynchroRate({ town, syncper_19, syncper_19_rank }) {
  return (
    <>
      <Paragraph>
        <span>
          그렇다면 싱크로율은 얼마나 높았을까요? 저희가 각 선거에서 후보들이
          받은 우리나라 전체 득표율과 {town}의 득표율의 오차를 계산해 봤더니
          우리 동네는 <PointText>{syncper_19}%</PointText>로 높은 싱크로율을
          보여줬어요. 전국에서 <PointText>{syncper_19_rank}</PointText>번째로
          높은 싱크로율을 보여줬어요
        </span>
      </Paragraph>
      <CompBar town={town} syncper_19={syncper_19} />
    </>
  );
}

export function CompTextVoteDir({ first }) {
  //TODO: winner_17 맞는지 확인
  const isJinboOrBosu = first.dirNum === 1 ? "보수" : "진보";
  const changePercent = Math.floor(first.percent * 100);
  const getColor = (value) => (value === 1 ? true : false);
  return (
    <Paragraph>
      <span>
        자~ 그렇다면 이번에는 역대 대선에서 민심의 바람이 어떻게 변했는지도
        확인해 보죠. 우리 동네는 16대에서 17대 대선으로 넘어가면서{" "}
        <PointText isColor={getColor(first.dirNum)}>{isJinboOrBosu}</PointText>
        쪽으로{" "}
        <PointText isColor={getColor(first.dirNum)}>{changePercent}</PointText>
        %p 득표율 변화를 보였어요. 지난 선거보다 더{" "}
        <PointText isColor={getColor(first.dirNum)}>{isJinboOrBosu}</PointText>
        화 됐다고 볼 수 있어요.
      </span>
    </Paragraph>
  );
}

export function CompTextVoteDirTwo({ sido, second, third, best_shift_18_19 }) {
  const isSecondJinboOrBosu = second.dirNum === 1 ? "보수" : "진보";
  const isThirdJinboOrBosu = third.dirNum === 1 ? "보수" : "진보";
  const getColor = (value) => (value === 1 ? true : false);
  const changePercent = (value) => Math.floor(value * 100);
  return (
    <Paragraph>
      <span>
        17대 대선에서 18대 대선으로 넘어가면서 표심은{" "}
        <PointText isColor={getColor(second.dirNum)}>
          {isSecondJinboOrBosu}
        </PointText>{" "}
        쪽으로{" "}
        <PointText isColor={getColor(second.dirNum)}>
          {changePercent(second.percent)}%p
        </PointText>{" "}
        돌아섭니다. 가장 최근 민심을 볼 수 있는 18대에서 19대 대선으로 넘어오면
        어떨까요?{" "}
        <PointText isColor={getColor(third.dirNum)}>
          {isThirdJinboOrBosu}
        </PointText>{" "}
        쪽으로{" "}
        <PointText isColor={getColor(third.dirNum)}>
          {changePercent(third.percent)}%p
        </PointText>{" "}
        득표율 변화를 보였습니다. 전국에서{" "}
        <PointText>{best_shift_18_19}</PointText>
        번째 높은 수치였군요.
      </span>
      <span>
        우리 동네뿐만 아니라 <PointText>{sido}</PointText>에 속한 다른 시군구
        풍향계와 비교해 볼까요?
      </span>
    </Paragraph>
  );
}
